(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p31-loop-video"] && !Shopify.designMode) return;
  try {
    (() => {
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const shouldPlay = state => state.near && !document.hidden && !reduced.matches && !state.userPaused;
  const clearWatch = state => { clearTimeout(state.watch); state.watch = null; };
  const stop = state => {
    if (!state.video.paused) {
      state.systemPause = true;
      state.video.pause();
    }
  };
  const updateFallback = state => {
    const active = shouldPlay(state);
    const source = active ? state.image.dataset.src : state.video.poster;
    if (state.image.getAttribute('src') !== source) state.image.setAttribute('src', source);
    state.toggle.textContent = state.userPaused ? state.toggle.dataset.resume : state.toggle.dataset.pause;
  };
  const hideFallback = state => {
    state.fallbackMode = false;
    state.video.hidden = false;
    if (!state.image) return;
    state.image.hidden = true;
    state.image.removeAttribute('src');
    state.controls.hidden = true;
  };
  const showFallback = state => {
    if (!state.image || state.manualVideo || !shouldPlay(state) || !state.video.paused) return;
    clearWatch(state);
    state.fallbackMode = true;
    state.video.autoplay = false;
    state.video.hidden = true;
    state.image.hidden = false;
    state.controls.hidden = false;
    updateFallback(state);
  };
  const sync = state => {
    if (state.fallbackMode && reduced.matches) hideFallback(state);
    if (state.fallbackMode) { updateFallback(state); return; }
    if (!shouldPlay(state)) { clearWatch(state); state.video.autoplay = false; stop(state); return; }
    state.video.autoplay = true;
    if (!state.video.paused || state.pending) return;
    state.video.defaultMuted = true;
    state.video.muted = true;
    state.video.playsInline = true;
    state.video.loop = true;
    state.pending = true;
    state.watch = setTimeout(() => showFallback(state), 2500);
    Promise.resolve(state.video.play()).then(() => {
      state.pending = false;
      clearWatch(state);
      if (state.fallbackMode || !shouldPlay(state)) stop(state);
    }).catch(error => {
      state.pending = false;
      if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') showFallback(state);
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (!state) return;
      state.near = entry.isIntersecting;
      sync(state);
    });
  }, {rootMargin: '0px', threshold: 0}) : null;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-p31-loop-video][data-auto-loop="true"]').forEach(wrapper => {
      if (states.has(wrapper)) return;
      const video = wrapper.querySelector('video');
      const state = {video, wrapper, image: wrapper.querySelector('[data-motion-image]'), controls: wrapper.querySelector('[data-motion-controls]'), toggle: wrapper.querySelector('[data-motion-toggle]'), near: !observer, userPaused: false, systemPause: false, pending: false, fallbackMode: false, manualVideo: false, watch: null, controlIntentUntil: 0};
      states.set(wrapper, state);
      video.addEventListener('pause', () => {
        if (!state.fallbackMode && !state.systemPause && state.near && !document.hidden && !video.ended && Date.now() < state.controlIntentUntil) state.userPaused = true;
        state.systemPause = false;
      });
      video.addEventListener('play', () => {
        if (state.fallbackMode) { stop(state); return; }
        state.userPaused = false;
        clearWatch(state);
      });
      ['pointerdown', 'touchstart', 'keydown'].forEach(type => {
        video.addEventListener(type, () => { state.controlIntentUntil = Date.now() + 1500; }, {passive: true});
      });
      video.addEventListener('loadedmetadata', () => sync(state));
      video.addEventListener('canplay', () => sync(state));
      state.toggle?.addEventListener('click', () => { state.userPaused = !state.userPaused; updateFallback(state); });
      wrapper.querySelector('[data-motion-video]')?.addEventListener('click', () => {
        hideFallback(state);
        state.manualVideo = true;
        state.userPaused = false;
        state.pending = false;
        video.play().catch(() => {});
      });
      state.image?.addEventListener('error', () => {
        hideFallback(state);
        state.manualVideo = true;
      });
      sync(state);
      observer?.observe(wrapper);
    });
  };
  document.addEventListener('visibilitychange', () => states.forEach(sync));
  window.addEventListener('pageshow', () => states.forEach(sync));
  document.addEventListener('touchend', event => {
    if (event.target.closest?.('[data-p31-loop-video]')) return;
    states.forEach(sync);
  }, {passive: true});
  reduced.addEventListener('change', () => states.forEach(sync));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, wrapper) => {
      if (!event.target.contains(wrapper)) return;
      clearWatch(state);
      state.near = false;
      stop(state);
      hideFallback(state);
      observer?.unobserve(wrapper);
      states.delete(wrapper);
    });
  });
  initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p33-market"] && !Shopify.designMode) return;
  try {
    (() => {
  const element = document.getElementById('P33MarketContext');
  if (!element) return;
  const context = JSON.parse(element.textContent);
  if (context.designMode) return;
  const url = new URL(location.href);
  url.searchParams.delete('porin_lang');
  const needsCountry = context.us === 'US' && context.currency !== 'USD';
  const needsLanguage = context.english === 'en' && context.language !== 'en';
  const key = context.country + ':' + context.currency + ':' + context.language;
  let attempted;
  try { attempted = sessionStorage.getItem('p33-market-attempt'); } catch {}
  if ((needsCountry || needsLanguage) && attempted !== key) {
    try { sessionStorage.setItem('p33-market-attempt', key); } catch {}
    const form = document.getElementById('P33Localization');
    if (needsCountry) form.elements.country_code.value = 'US';
    form.elements.return_to.value = url.pathname + url.search + url.hash;
    form.requestSubmit();
  } else {
    if (!needsCountry && !needsLanguage) { try { sessionStorage.removeItem('p33-market-attempt'); } catch {} }
    if (url.href !== location.href) history.replaceState(null, '', url);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["porin-reviews"] && !Shopify.designMode) return;
  try {
    const reviewForm = document.getElementById('PorinReviewForm');
if (reviewForm && reviewForm.querySelector('[role=status], [role=alert]')) reviewForm.closest('details').open = true;
  } catch(e) { console.error(e); }
})();

})();
